import {type StudioLocaleResourceKeys} from '../../../../../../../../../../../i18n'

export const SHORT_WEEK_DAY_KEYS: StudioLocaleResourceKeys[] = [
  'calendar.weekday-names.short.monday',
  'calendar.weekday-names.short.tuesday',
  'calendar.weekday-names.short.wednesday',
  'calendar.weekday-names.short.thursday',
  'calendar.weekday-names.short.friday',
  'calendar.weekday-names.short.saturday',
  'calendar.weekday-names.short.sunday',
]

export const ARROW_KEYS = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight']

// all weekdays except first
export const TAIL_WEEKDAYS = [1, 2, 3, 4, 5, 6]
